export const mpsvTargetGroupFrag = `
    id
    name
`;
